<c-card *transloco="let t">
    <c-card-body class="px-2" *ngIf="workers">
  
        <c-row>
          <c-col class="col-lg-6 col-12">
            <h1>{{ t('Safety Monitoring Center Validation') }}</h1>
            <p>{{ t('Your account is setup to use our Safety Monitoring Center. So workers can start their shifts and successfully get alerts they have to be setup correctly. This report shows a list of workers and any issues with may have with their setup') }}</p>
          </c-col>
        </c-row>

        <c-row class="justify-content-end">

          <c-col class="col-12 col-lg-6">
  
          <div class="card mb-2">
            <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Workers') }}
            </div>
            <div class="collapse" id="collapseExample">
              <div class="card-body">
  
                <form cForm >
  
                  <div class="row mb-3">
                    <label  class="col-sm-4 col-form-label text-end" for="search">
                      <b>{{ t('Search') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <input cFormControl id="search" name="search" placeholder="{{ t('Search') }}" [(ngModel)]="search"/>
                    </div>
                  </div>
  
  
  
                  <div class="row mb-3" *ngIf="!okService.isExtendedPrivacy()">
                    <label  class="col-sm-4 col-form-label text-end" for="monitors">
                      <b>{{ t('Shown Workers') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <select aria-label="Default select example" name="monitors" cSelect [(ngModel)]="monitor">
                        <option value="all">{{ t('All Workers') }}</option>
                        <option value="mine">{{ t('My Monitored') }}</option>
                      </select>
                    </div>
                  </div>
  
                  <div class="row mb-3" *ngIf="groups.length> 0 && okService.hasFeature('groups')">
                    <label  class="col-sm-4 col-form-label text-end" for="monitors">
                      <b>{{ t('Worker Group') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <ng-select
                      [items]="groups"
                      name="group"
                      [(ngModel)]="group"
                      bindLabel="name"
                      bindValue="id">
                    </ng-select>
                    </div>
                  </div>
  
  
  
                  <button cButton class="btn btn-primary" type="submit"  (click)="updateFilter()">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <span class="d-none d-lg-inline">
                        {{ t('Search') }}
                    </span>
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                      <i class="fa-solid fa-xmark"></i>
                    <span class="d-none d-lg-inline">
                       {{ t('Clear Filter') }}
                    </span>
                  </button>
  
  
                </form>
  
              </div>
            </div>
          </div>
        </c-col>
        <c-col class="col-12 col-lg-6">
  
        <c-row class="justify-content-end">
  
          
          <c-col xs="auto" class="mb-2">
            <button cButton class="btn btn-light" type="submit"  (click)="errors_only=!errors_only">
            <span class="d-none d-lg-inline" *ngIf="!errors_only">
              {{ t('Show only Workers with Issues') }}
            </span>
            <span class="d-none d-lg-inline" *ngIf="errors_only">
              {{ t('Show All Workers') }}
            </span>
          </button>
          </c-col>
  
          <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages > 1">
            <c-input-group  class="text-end">
              <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
              <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
              </select>
            </c-input-group>
          </c-col>
          <c-col xs="auto" class="mb-2">
            <c-input-group>
              <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
              <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                <option value="newest">{{ t('Newest') }}</option>
                <option value="oldest">{{ t('Oldest') }}</option>
                <option value="name">{{ t('Name') }}</option>
              </select>
            </c-input-group>
          </c-col>
        </c-row>
          </c-col>
        </c-row>


        <c-row *ngIf="workers">
          <c-col>

            <table
            [hover]="true"
            [responsive]="true"
            [striped]="true"
            cTable
            class="mb-0 border"
            >
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ t('PIN') }}</th>
                  <th scope="col">{{ t('Worker') }}</th>
                  <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                  <th scope="col">{{ t('Monitors') }}</th>
                  <th scope="col" *ngIf="this.okService.groups && this.okService.groups.length > 0">{{ t('Groups') }}</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let worker of workers" [ngClass]="worker.arc && worker.arc.valid.valid ? 'table-success' : 'table-danger'" [hidden]="errors_only && worker.arc.valid.valid">
                    <td>
                      <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/worker/{{worker.id}}">
                        <svg cIcon class="me-2" name="cil-pencil"></svg>
                      </button>
                    </td>
                    <th scope="row">
                      <div>
                        <span class="badge bg-light text-dark fs-5">{{ u.formatWorkerPin(worker.pin) }}</span>
                      </div>
                    </th>
                    <td>
                      <span><b class="fs-5">{{worker.name}}</b></span>
                    </td>
                    <td>
                      {{worker.email}}
                      <div class="small text-medium-emphasis">
                        <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                      </div>
                    </td>
                    <th>
                      <div class="small text-medium-emphasis">
                        <ng-container *ngFor="let monitor_name of worker.monitor_names; let i = index">
                          <span class="pointer" routerLink="/mgmt/monitor/{{worker.monitors[i]}}">{{ monitor_name }}&nbsp;&nbsp;</span>
                        </ng-container>
                      </div>
                    </th>
                    <th *ngIf="this.okService.groups.length > 0">
                      <div class="small text-medium-emphasis">
                        <ng-container *ngFor="let group_name of worker.group_names; let i = index">
                          <span class="pointer" routerLink="/mgmt/group/{{worker.group_ids[i]}}">{{ group_name }}&nbsp;&nbsp;</span>
                        </ng-container>
                      </div>
                    </th>
                    <td class="text-left">
                        @if(worker.arc && !worker.arc.valid.valid){
                          <ul>
                            @for (error of worker.arc.valid.errors; track error) {
                            <li>{{error}}</li>
                            }
                          </ul>
                        }
                    </td>
                  </tr>
                </tbody>

            </table>

          </c-col>
        </c-row>

        
  </c-card-body>
</c-card>
  